import { usageLog } from "../features/api/dts_api_wrapper";

export type EvaluateUsageLogProps = {
  userId: string;
  displayPage: string;
  displayDateTime: string;
  additionalInfo: string;
};

// Good・Bad更新時の利用ログ登録
export const useEvaluateUsageLog = () => {
  const handleEvaluationUsageLog = async ({
    userId,
    displayPage,
    displayDateTime,
    additionalInfo,
  }: EvaluateUsageLogProps) => {
    try {
      if (!userId) {
        //何らかの理由でuserIdが読み込めなかった
        throw new Error("userId is unknown");
      }
      //利用ログ登録
      const usageLogResult = await usageLog(
        userId,
        displayPage,
        displayDateTime,
        additionalInfo
      );
      //　現在は利用ログでエラーが出た場合, エラー文をthrow
      if ("errorMessage" in usageLogResult) {
        throw new Error(usageLogResult.errorMessage);
      }
      // 正常に終了した場合, trueを返す
      return true;
    } catch (err) {
      console.log(`[${displayPage}]err: ${err}`);
      if (
        err instanceof Error &&
        (err.message === "Expired token" || err.message === "Invalid token")
      ) {
        //トークン切れの場合、受け取ったエラーをそのまま呼び出し元に投げる
        throw err;
      }
      // エラーの場合, falseを返す
      return false;
    }
  };

  return {
    handleEvaluationUsageLog,
  };
};
